import React from 'react';
import { List, ListItem, ListItemText } from '@material-ui/core';

import { lighterGray } from 'utils/color-styles';
import { CurrencyCode } from 'utils/currencyFormat';
import { CurrencyFormat } from 'retired/CurrencyFormat';

interface CurrencyAmountEstimationMessageProps {
  targetCurrency: CurrencyCode;
  totalAmount: number;
  currency: CurrencyCode;
  message: JSX.Element;
  title: JSX.Element;
}

export const CurrencyAmountEstimationMessage = ({
  targetCurrency,
  totalAmount,
  currency,
  message,
  title,
}: CurrencyAmountEstimationMessageProps): JSX.Element => (
  <List style={{ maxHeight: 560, overflow: 'auto' }}>
    <ListItem style={{ backgroundColor: lighterGray, borderRadius: 16 }}>
      <ListItemText
        secondary={
          <div
            style={{
              display: 'flex',
              gap: 10,
              lineHeight: 1.5,
              alignItems: 'top',
            }}
          >
            <div style={{ flex: 1, maxWidth: 195 }}>
              <div style={{ marginBottom: 10 }}>{title}</div>
              <CurrencyFormat
                amount={totalAmount}
                targetCurrency={targetCurrency}
                baseCurrency={currency}
              />
            </div>
            <div style={{ flex: 3 }}>{message}</div>
          </div>
        }
      />
    </ListItem>
  </List>
);
